/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalReferralResponse
 */
export interface ExternalReferralResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExternalReferralResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExternalReferralResponse
     */
    referral_id?: string;
}

/**
 * Check if a given object implements the ExternalReferralResponse interface.
 */
export function instanceOfExternalReferralResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalReferralResponseFromJSON(json: any): ExternalReferralResponse {
    return ExternalReferralResponseFromJSONTyped(json, false);
}

export function ExternalReferralResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalReferralResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'referral_id': !exists(json, 'referral_id') ? undefined : json['referral_id'],
    };
}

export function ExternalReferralResponseToJSON(value?: ExternalReferralResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'referral_id': value.referral_id,
    };
}

